<div class="dispersionchart-container"
  style="position: relative; width:100%">
  <canvas #canvasItem></canvas>
</div>
